import './contact-confirm-appointment-deletion.component.ajscss';

import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './contact-confirm-appointment-deletion.component.ajs.html';

export class ContactConfirmAppointmentDeletionCtrl implements IComponentController {
  close: Function;
  dismiss: Function;

  $onInit() {}
}

export class ContactConfirmAppointmentDeletion implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    close: '&',
    dismiss: '&',
  };
  controller = [ContactConfirmAppointmentDeletionCtrl];
}

export default 'contactConfirmAppointmentDeletion';
